import React from 'react';
import { Alert, Box, Button, Paper, Stack, Typography } from '@mui/material';

type Props = {
  saving?: boolean;
  error?: string | null;
  notice?: string | null;
  onSave: () => void;
};

export const SafetyCaseAttestationSaveBar: React.FC<Props> = ({
  saving = false,
  error = null,
  notice = null,
  onSave,
}) => (
  <Paper
    variant="outlined"
    sx={{
      position: 'sticky',
      bottom: 16,
      zIndex: 2,
      p: 2,
      borderRadius: 3,
      bgcolor: 'background.paper',
      boxShadow: 3,
    }}
    data-testid="safety-case-attestation-save-bar"
  >
    <Stack spacing={1.5}>
      <Box>
        <Typography variant="subtitle1" sx={{ fontWeight: 800 }}>
          Save Safety Case attestation
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Saves workplace condition, contributing review, closure summary, and follow-up result together for scan sign-off.
        </Typography>
      </Box>
      {error ? <Alert severity="error">{error}</Alert> : null}
      {notice ? <Alert severity="success">{notice}</Alert> : null}
      <Box>
        <Button variant="contained" onClick={onSave} disabled={saving} sx={{ fontWeight: 800 }}>
          {saving ? 'Saving…' : 'Save Safety Case attestation'}
        </Button>
      </Box>
    </Stack>
  </Paper>
);

export default SafetyCaseAttestationSaveBar;
